import { render, staticRenderFns } from "./book.module.vue?vue&type=template&id=2c653604&scoped=true"
import script from "./book.module.vue?vue&type=script&lang=js"
export * from "./book.module.vue?vue&type=script&lang=js"
import style0 from "./book.module.vue?vue&type=style&index=0&id=2c653604&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c653604",
  null
  
)

export default component.exports